module.exports = __webpack_public_path__ + "img/dongtaihuozhi.039ad551.png";